<template>
    <chartist
      class="v-card--material-chart"
      :data="data"
      :event-handlers="eventHandlers"
      :options="options"
      :ratio="ratio"
      :responsive-options="responsiveOptions"
      :type="type"
    />

</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    eventHandlers: {
      type: Array,
      default: () => ([])
    },
    options: {
      type: Object,
      default: () => ({})
    },
    ratio: {
      type: String,
      default: undefined
    },
    responsiveOptions: {
      type: Array,
      default: () => ([])
    },
    type: {
      type: String,
      required: true,
      validator: v => ['Bar', 'Line', 'Pie'].includes(v)
    }
  }
}
</script>

<style lang="scss">
  .v-card--material-chart {
      .ct-label {
        color: black;
        opacity: 1;
        font-size: 0.875rem;
        font-weight: 200;
      }

      .ct-bar {
        stroke-width: 25px;
      }

      .ct-series-a .ct-bar {
        stroke: lightblue;
      }
      .ct-series-b .ct-bar {
        stroke: orangered;
        opacity: 0.9;
      }
  }
</style>
